import { render, staticRenderFns } from "./DefaultFieldset.vue?vue&type=template&id=081e337d&"
import script from "./DefaultFieldset.vue?vue&type=script&lang=js&"
export * from "./DefaultFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports